import { render, staticRenderFns } from "./ElderlyGovForReg.vue?vue&type=template&id=2c2e5b19&scoped=true&"
import script from "./ElderlyGovForReg.vue?vue&type=script&lang=js&"
export * from "./ElderlyGovForReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e5b19",
  null
  
)

export default component.exports